import DatePicker from '../date-picker/DatePicker';
import { ViewMode } from '../date-picker/enum';
export default class MonthPicker extends DatePicker {
    getWrapperClassNames() {
        const { prefixCls } = this;
        return super.getWrapperClassNames(`${prefixCls}-month-picker-wrapper`);
    }
}
MonthPicker.displayName = 'MonthPicker';
MonthPicker.defaultProps = {
    ...DatePicker.defaultProps,
    mode: ViewMode.month,
};
